import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  gap: ${spacers?.spacers?.[3]};
`;
